module.exports = __webpack_public_path__ + "img/emptypng.91f3dade.png";